module.exports = __webpack_public_path__ + "img/2_180.88c8edcb.png";